import React, { useState } from "react";
import "./style.css";
import MainHeading from "../Utils/mainHeading";
import Map from "../../Components/Map";
import GoogleMap1 from "../../Components/Map2";
import GlobeMap from "../Globe";
import { useTranslation } from "react-i18next";

export default function OurLocations() {
    const { t ,i18n} = useTranslation();
    const [selectedLocationId, setSelectedLocationId] = useState(null);

    const locations = [
        { id: 1, name: "Kuwait" ,address:"555 Madison Avenue, 17th Floor, New York, NY 10022" },
        { id: 2, name: "Paris" ,address:"555 Madison Avenue, 17th Floor, New York, NY 10022" },
        { id: 3, name: "Amsterdam" ,address:"555 Madison Avenue, 17th Floor, New York, NY 10022" },
        { id: 4, name: "Istanbul" ,address:"555 Madison Avenue, 17th Floor, New York, NY 10022"},
        { id: 5, name: "Washington" ,address:"555 Madison Avenue, 17th Floor, New York, NY 10022" },
        { id: 6, name: "London" ,address:"555 Madison Avenue, 17th Floor, New York, NY 10022" },
    ];

    const handleLocationClick = (id) => {
        setSelectedLocationId(id === selectedLocationId ? null : id); // Toggle the selected location
    };

    return (
        <div className="our_locations">
            <MainHeading width={'95%'} align={'center'} gap={'13px'} flexDirection={'row'} content1={t("ourlocation.firstpart")} content2={t("ourlocation.secondpart")} />
            <div className="map_parent_section">
                {/* <div className="map">
                <GoogleMap1/>
                </div> */}
                <GlobeMap/>
                {/* <div className="locations_descriptions">
                    {locations.map((location) => (
                        <div
                            key={location.id}
                            className={`location_detail ${selectedLocationId === location.id ? "active" : ""}`}
                            onClick={() => handleLocationClick(location.id)}
                        >
                            <h1>{location.name}</h1>
                            {selectedLocationId === location.id && <p>{location.address}</p>}
                        </div>
                    ))}
                </div> */}
            </div>
        </div>
    );
}
